<script>
  import { createEventDispatcher } from 'svelte';
  import ListsSelected from './PinnedListsSelected.svelte';
  import ListsSelector from './PinnedListsSelector.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';

  const dispatch = createEventDispatcher();
  let user = getCurrentUserStore('default');

  export let mobile = false;
  let showListsSelected = true;
  let showListsSelector = false;
  $: selectedLists = [];
  $: allLists = [];

  const loadAllLists = async function () {
    let res = await CreatorSpotlightAjax.getAllLists();
    allLists = res.groups;
  };

  let loadPinnedLists = async function () {
    let res = await CreatorSpotlightAjax.getCreatorSpotlightInformation(user);
    selectedLists = res.pinned_lists;
    return res;
  };

  let deleteList = async function (e) {
    let res = await CreatorSpotlightAjax.updatePinnedStatusOfGroup(e.detail, false);
    loadPinnedLists();
    return res;
  };

  let addList = async function (e) {
    let res = await CreatorSpotlightAjax.updatePinnedStatusOfGroup(e.detail, true);
    goToListsSelected();
    return res;
  };

  let goToListsSelected = function () {
    loadPinnedLists();
    showListsSelected = true;
    showListsSelector = false;
  };

  let goToListsSelector = function () {
    loadPinnedLists();
    loadAllLists();
    showListsSelected = false;
    showListsSelector = true;
  };

  loadAllLists();
  loadPinnedLists();
</script>

<div>
  <div style={showListsSelected ? 'display: block' : 'display: none'}>
    <ListsSelected
      mobile={mobile}
      on:close={() => dispatch('close')}
      on:back={() => dispatch('back')}
      on:finish={() => dispatch('finish')}
      on:goToListsSelector={() => goToListsSelector()}
      on:delete={(e) => deleteList(e)}
      selectedLists={selectedLists} />
  </div>
  <div style={showListsSelector ? 'display: block' : 'display: none'}>
    <ListsSelector
      mobile={mobile}
      on:close={() => dispatch('close')}
      on:back={() => goToListsSelected()}
      on:add={(e) => addList(e)}
      lists={allLists} />
  </div>
</div>
